import {ContentViewModel} from '@levelapp/softfabric';
import PosSimButtonViewState from './PosSimButtonViewState';
import PosSimButtonViewProps from './PosSimButtonViewProps';

export default class PosSimButtonViewModel extends ContentViewModel<PosSimButtonViewState, PosSimButtonViewProps>{}